<!-- Active Filters as Chips -->

<div class="chipset-wrapper">
  <mat-chip-set class="filter-option-chips">
    <ng-container *ngFor="let filter of activeFilters; let i = index">
      <mat-chip-option *ngIf="!isDateFilter(filter)" selectable="false" [removable]="true" (removed)="removeFilter(i)">
        {{ filter.key.display_key }}: <strong>{{ filter.value }}</strong>
        <mat-icon matChipRemove>close</mat-icon>
      </mat-chip-option>
    </ng-container>
    <mat-chip [matMenuTriggerFor]="filterType" #menuTrigger="matMenuTrigger">
      Filter<mat-icon matChipAvatar>filter_list</mat-icon>
    </mat-chip>
  </mat-chip-set>
  <span class="example-spacer"></span>

  <mat-form-field appearance="fill" style="min-width: fit-content;">
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
      <input matStartDate formControlName="start" placeholder="Start date" />
      <input matEndDate formControlName="end" placeholder="End date" />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker
      [calendarHeaderComponent]="PTicketFilterPresetComponent"><mat-date-range-picker-actions>
        <button mat-button matDateRangePickerCancel>Cancel</button>
        <button mat-raised-button color="primary" (click)="applySelectedDate(picker)"
          [disabled]="pickerService.applyDisabled | async" matDateRangePickerApply>
          Apply
        </button>
      </mat-date-range-picker-actions>
    </mat-date-range-picker>
  </mat-form-field>

</div>




<!-- First Menu: Select Filter Type -->
<mat-menu #filterType="matMenu">
  <button mat-menu-item *ngFor="let filter of filterOptions" [matMenuTriggerFor]="filterOption"
    [matMenuTriggerData]="{ key : filter , options : filter.options}">
    {{ filter.display_key }}
  </button>
</mat-menu>


<mat-menu #filterOption="matMenu">
  <ng-template matMenuContent let-key="key" let-options="options">
    <ng-container *ngFor="let option of options">
      <button mat-menu-item (click)="addFilter(key, option)" *ngIf="!key.customFilter">
        {{ option }}
      </button>
      <div *ngIf="key.customFilter" class="custom-filter">
        <mat-form-field (click)="$event.stopPropagation()">
          <mat-label>{{ key.display_key }}</mat-label>
          <input matInput [matAutocomplete]="CountryCodeAuto" (input)="filterKeywords($event)"
            (keydown)="$event.stopPropagation()" #countryFilterInput />
           <mat-autocomplete #CountryCodeAuto="matAutocomplete" (optionSelected)="addFilter(key, countryFilterInput.value)">
            <mat-option *ngFor="let entry of filteredcountryCodes" [value]="entry.cod_alpha2">
                <div class="option-primary">{{ entry.cod_alpha2 }}</div>
                <div class="option-secondary">
                    {{ entry.cod_countrycode }} | {{ entry.cod_countryname }}
                </div>
            </mat-option>
        </mat-autocomplete>
        </mat-form-field>

        <button mat-stroked-button color="primary" (click)="addFilter(key, countryFilterInput.value)">Apply</button>
      </div>
    </ng-container>
  </ng-template>
</mat-menu>